import * as Styles from './HeaderTabSelector.styles';

export type Size = 'sm' | 'md';

type HeaderTabSelectorProps<T extends string> = {
  options: T[];
  value: T;
  labels?: { [value in T]: string };
  onChange?: (value: T) => void;
  size?: Size;
  className?: string;
};

const HeaderTabSelector = <T extends string = string>({
  options,
  value,
  labels,
  onChange,
  size = 'md',
  className,
}: HeaderTabSelectorProps<T>): JSX.Element => (
  <Styles.List className={className}>
    {options.map((item) => (
      <li key={item}>
        <Styles.Button active={item === value} onClick={() => onChange?.(item)} size={size}>
          {labels?.[item] || item}
        </Styles.Button>
      </li>
    ))}
  </Styles.List>
);

export default HeaderTabSelector;
